module.exports = __webpack_public_path__ + "img/mort-prot.a3eabb4.svg";